<div style="overflow-y:hidden;overflow-x:hidden;padding: 0px">
  <div style="position:relative;">
    <img src="assets/images/doctor-1x.png" style="position:absolute;right:0;z-index:-10;" class="doctor-ipad doctor d-none d-lg-block"/>
  </div>

  <div class="row">
    <div class="col-lg-9" style="padding-left:25px;padding-top:5px;">
      <div class="row">
        <div class="col-lg-12">
          <span class="heading-bold">Introduction</span> <span class="heading-normal"> to</span> <br /> <span class="heading-bold">Panadol Science Map</span>
        </div>

      </div>
      <div class="row">
        <div class="col-lg-8 col-md-8 col-sm-12" style="margin-top:30px;border-top:2px solid black">
          <table style="width:100%;" class="intro-table">
            <tr>
              <td><img src="assets/images/bullet.png" class="bullet-icon" /></td>
              <td>
                The Panadol Science Maps are designed to provide a simple way to visually
                depict the efficacy of Panadol across multiple indications.
              </td>
            </tr>
            <tr>
              <td><img src="assets/images/bullet.png" class="bullet-icon" /></td>
              <td>
                The <strong>maps gives “at-a-glance” overview of efficacy and suitability</strong> of
                Panadol/Panadol Extra and Panadol kids compared to the comparator drugs
                like non-steroidal anti-inflammatory drugs (NSAIDs) in various indications.
                There is a one-pager summary for each trial/study covered in the
                science map.
              </td>
            </tr>
            <tr>
              <td><img src="assets/images/bullet.png" class="bullet-icon" /></td>
              <td> It also highlights the <strong>unsurpassed suitability of Panadol</strong> among OTC oral medications used for pain relief in terms of gastric irritation, cardiovascular tolerance and interaction between drugs.</td>
            </tr>
            <tr>
              <td><img src="assets/images/bullet.png" class="bullet-icon" /></td>
              <td>The Guideline Map gives an overview of <strong>Paracetamol recommendation in national and international clinical practice guidelines</strong> for common pain conditions.</td>
            </tr>

          </table>
        </div>
      </div>
      <div style="line-height:10px;">
        <span class="footer-text">Instructions</span> <br />
        <span class="footer-text-small">
          Click on the study number or the author name to see <br />
          the study details and summary.
        </span>
      </div>
      <div class="row">
        <div class="col-lg-6 col-md-5 col-sm-12">
          <table style="width:100%;" class="legend-table">
            <tr>
              <td><div class="intro-legend bg-green"></div></td>
              <td>
                Panadol is significantly better than the comparator
              </td>
            </tr>
            <tr>
              <td><div class="intro-legend bg-yellow"></div></td>
              <td>
                No statistical difference between Panadol and the comparator
              </td>
            </tr>
            <tr>
              <td><div class="intro-legend bg-pink"></div></td>
              <td>
                Comparator is better than paracetamol
              </td>
            </tr>
            <tr>
              <td><div class="intro-legend bg-grey"></div></td>
              <td>No comparative data available</td>
            </tr>

          </table>
        </div>
      </div>
    </div>
  </div>
</div>
